import axios from 'axios';

import type { GENERATIVE, OUT_OF_STOCK } from '@/components/patient/enquiryModal/common';
import settings from '@/constants/constants';
import type { ProductOfferingResponse } from '@montugroup/circuit-shared';
import type { ProductEnquiryStatus } from '@montugroup/circuit-shared/types/enquiry';

const fetchProductEnquiryStatus = async (
  patientId?: number,
  prescriptionId?: number,
  productId?: number,
  rescriptRequestReason?: typeof GENERATIVE | typeof OUT_OF_STOCK,
) => {
  const result = await axios<ProductEnquiryStatus>(
    `${settings.url}/patient/${patientId}/product-enquiry-status?prescriptionId=${prescriptionId}&productId=${productId}&rescriptRequestReason=${rescriptRequestReason}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  return result.data;
};

const productCatalog = (excludeDiscontinuedProducts = false) =>
  axios.get(`${settings.url}/product/catalog?excludeDiscontinuedProducts=${excludeDiscontinuedProducts === true}`);

const getProductOffering = (id: string) => axios.get<ProductOfferingResponse>(`${settings.url}/product/offering/${id}`);

export { fetchProductEnquiryStatus, getProductOffering, productCatalog };
